var shareSyncType = {
    Disabled: 0,
    Share: 1,
    Sync: 2,
};

export default shareSyncType;